'use strict';

import type { GlobSunfireOrg } from '../../Entities/Glob/GlobSunfireOrg';
import { EntityCollection } from '../EntityCollection';

export class GlobSunfireOrgCollection extends EntityCollection<GlobSunfireOrg> {}
